import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import noop from "shared/util/noop";

import C from "reflux/okmodal/util/Constants";

const CSS_PREFIX = `${C.CSS_PREFIX}Content`;

class Modal extends Component {
	state = {
		mountTime: Date.now(),
	};

	render() {
		const classes = classnames(CSS_PREFIX, this.props.className);
		const body = this.props.body.split("<br />");
		const ctaColor = this.props.ctaColor || "blue";
		const onDismiss = this.props.onDismiss || noop;
		let onAction = this.props.onAction || noop;

		// For analytic purposes
		if (this.props.seenModalAnalyticCallBack) {
			this.props.seenModalAnalyticCallBack();
		}

		if (this.props.trackViewDuration && this.props.onAction) {
			onAction = () => {
				this.props.onAction(this.state.mountTime);
			};
		}

		const wrapperClasses = classnames({
			[`${C.CSS_PREFIX}-wrapper`]: true,
			"hasWindowshade": this.props.windowshade,
		});

		return (
			<div
				className={wrapperClasses}
				onClick={onDismiss}
				role="presentation"
			>
				<div className={classes}>
					<header className={`${CSS_PREFIX}-header`}>
						<div className={`${CSS_PREFIX}-accent`} />
						{this.props.image &&
							<img
								className={`${CSS_PREFIX}-image`}
								src={this.props.image}
								alt="Illustration"
							/>
						}

						<h1 className={`${CSS_PREFIX}-headline`}>
							{this.props.headline}
						</h1>
					</header>
					<section className={`${CSS_PREFIX}-main`}>
						{this.props.subheadline &&
							<h2 className={`${CSS_PREFIX}-subheadline`}>
								{this.props.subheadline}
							</h2>
						}

						{this.props.body &&
							<div className={`${CSS_PREFIX}-body`}>
								{body.map((text, i) => {
									return (
										<span key={i}>
											{i > 0 &&
												<br />
											}
											<span dangerouslySetInnerHTML={{ __html: text }} />
										</span>
									);
								})}
							</div>
						}

						<div className={`${CSS_PREFIX}-button`}>
							<a
								className={`flatbutton ${ctaColor}`}
								href={this.props.ctaLink}
								onClick={onAction}>{this.props.ctaText}
							</a>
						</div>

						{this.props.dismissText &&
							<button
								className={`${CSS_PREFIX}-dismiss`}
								onClick={onDismiss}
							>
								<span>{this.props.dismissText}</span>
							</button>
						}
					</section>
				</div>
			</div>
		);
	}
}

Modal.propTypes = {
	body: PropTypes.string,
	className: PropTypes.string,
	ctaLink: PropTypes.string,
	ctaText: PropTypes.string,
	ctaColor: PropTypes.string,
	dismissText: PropTypes.string,
	headline: PropTypes.string,
	image: PropTypes.string,
	onAction: PropTypes.func,
	subheadline: PropTypes.string,
	windowshade: PropTypes.bool,

	onDismiss: PropTypes.func,
	seenModalAnalyticCallBack: PropTypes.func,
	trackViewDuration: PropTypes.bool,
};

Modal.defaultProps = {
	body: null,
	className: "",
	ctaLink: "",
	ctaText: "",
	ctaColor: "",
	dismissText: "",
	headline: "",
	image: "",
	onAction: () => {},
	subheadline: "",
	windowshade: false,

	onDismiss: () => {},
	seenModalAnalyticCallBack: () => {},
	trackViewDuration: false,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/reflux/okmodal/components/Modal.jsx